<template>
  <img :src="logoSrc" :alt="alt" />
</template>

<script setup>
  const props = defineProps({
    variant: {
      type: String,
      default: 'full',
      validator: (value) => ['full', 'circle'].includes(value)
    },
    tone: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'white'].includes(value)
    },
    alt: {
      type: String,
      default: 'FOREVER® Logo'
    }
  });

  const logoSrc = computed(() => {
    if (props.tone === 'white' && props.variant === 'circle') {
      return 'https://forever-mars-ui.s3.amazonaws.com/images/forever-logo-white-o.svg';
    }
    if (props.tone === 'white') {
      return 'https://forever-mars-ui.s3.amazonaws.com/images/forever-logo-white-v2.svg';
    }
    if (props.variant === 'circle') {
      return 'https://forever-mars-ui.s3.amazonaws.com/images/forever-logo-v2-o.svg';
    }
    return 'https://forever-mars-ui.s3.amazonaws.com/images/forever-logo-v2.svg';
  });
</script>
